import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
} from '@angular/core';
import { AttachmentListComponent } from '@app/components/attachment-list/attachment-list.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-obligations-tab',
  standalone: true,
  imports: [CommonModule, TranslatePipe, AttachmentListComponent],
  templateUrl: './obligations-tab.component.html',
  styleUrl: './obligations-tab.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ObligationsTabComponent {
  files = input.required<any[]>();

  readonly isLoading = signal<boolean>(false);
}
